export const pickFirst = <T>(item: T | T[]) => {
  if (Array.isArray(item)) {
    return item[0];
  }
  return item;
};

export const filterNotNull = <T>(value: T): value is NonNullable<T> =>
  value !== null;
